import { useRef } from 'react';
import cx from 'classnames';
import { useRouter } from 'next/router';
import { isStoreAppBannerEntry } from '@/utils/url';
import CommonImage, { ImageType } from '../CommonImage';
import Styles from './index.module.scss';

interface ICommonEquipment {
  home_page?: string;
  name: string;
  icon: string;
  className?: string;
  isLink?: boolean;
  showTooltip?: boolean;
  /** 禁用点击交互 */
  disableClick?: boolean;
}
const CommonEquipment = ({
  name,
  icon,
  className,
  isLink = true,
  home_page='javascript:void(0)',
  showTooltip = true,
  disableClick
}: ICommonEquipment) => {
  const router = useRouter();

  const imgContainerRef = useRef<any>();

  const onError = () => {
    const img = imgContainerRef.current?.querySelector('img');
    imgContainerRef.current.style.backgroundColor = '#E4E4E4';
    imgContainerRef.current.style.border = 'none';
    img.style.cssText='width: 20px; height: 20px;';
  }

  const tooltipClassName = showTooltip ? 'tooltip tooltipTop' : '';

  return (
    isLink ? 
      <a
        className={cx(tooltipClassName, [Styles.equipmentLink])}
        data-tooltip={name}
        target={(!disableClick && !isStoreAppBannerEntry(router.query.entry)) ? '_blank' : '_self'}
        href={(!disableClick && !isStoreAppBannerEntry(router.query.entry)) ? home_page : 'javascript:void(0)'}
      >
        <div
          className={cx([Styles.equipment], className)}
          ref={imgContainerRef}
        >
          <CommonImage
            src={icon??''}
            className={Styles.imgWrapper}
            cutMode="fill"
            type={ImageType.image}
            onError={onError}
          />
        </div>
      </a> : 
      <div
        className={cx(tooltipClassName, [Styles.equipmentLink])}
        data-tooltip={name}
      >
        <div
          className={cx([Styles.equipment], className)}
          ref={imgContainerRef}
        >
          <CommonImage
            src={icon??''}
            className={Styles.imgWrapper}
            cutMode="fill"
            type={ImageType.image}
            onError={onError}
          />
        </div>
      </div> 
  );
}

export default CommonEquipment;